import React, { Component } from "react";
import ResultHeader from "./result-header";
import DidYouMean from "./didYouMean";
import NoResults from "./noResults";
import ResultList from "./result-list";
import FiltersBar from "./filters-bar";
import Pagination from "./pagination";

import ResponsiveMenu from "./responsive-menu";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTimes,
  faCaretDown,
  faCaretUp,
  faChevronUp,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faPlus,
  faMinus,
  faLock,
  faBell,
  faSpinner} from '@fortawesome/free-solid-svg-icons'


import "./style.css";
import "./elss.css";

library.add(faTimes)
library.add(faCaretDown)
library.add(faCaretUp)
library.add(faChevronUp)
library.add(faChevronRight)
library.add(faChevronLeft)
library.add(faChevronDown)
library.add(faPlus)
library.add(faMinus)
library.add(faLock)
library.add(faSpinner)
library.add(faBell)



class SearchResults extends Component {
  staticFacetsMap = [
    {
      field: "source",
      displayName: "Site",
      values: [
        "e-LAB Solutions Suite",
        "CAP Website",
        "Newsroom",
        "Learning",
        "Online Store",
        "Foundation",
        "Annual Meeting",
      ],
    },
  ];

  staticFacetsMapELSS = [
    {
      field: "source",
      displayName: "Site",
      values: [
        "e-LAB Solutions Suite",
        "CAP Website",
        "Newsroom",
        "Learning",
        "Online Store",
        "Foundation",
        "Annual Meeting",
      ],
    },
  ];

  facetsNameMap = [
    {
      field: "source",
      displayName: "Site",
    },
    {
      field: "categories",
      displayName: "Category",
    },
    {
      field: "filetype",
      displayName: "File Type",
    },
  ];

  facetsNameMapELSS = [
    {
      field: "source",
      displayName: "Site",
    },
    {
      field: "filetype",
      displayName: "File Type",
    },
  ];

  facetsNameMapOSS = [
    {
      field: "yearstr",
      displayName: "Year",
    },
    {
      field: "discipline",
      displayName: "Discipline",
    },
  ];

  getStaticFacetsFromApp = () => {
    return [];
  };

  getFacetsFromApp = () => {
    switch (this.props.app) {
      case "cap-web":
        return this.facetsNameMap;
      case "ELSS":
        return this.facetsNameMapELSS;
      case "OSS":
        return this.facetsNameMapOSS;
      default:
        return this.facetsNameMap;
    }
  };

  state = {
    staticFacets: this.staticFacetsMap,
    facets: this.staticFacetsMap,
  };

  render() {
    return (
      <div className={`result-main-wrapper ${this.props.app}`}>
        {this.props.results.facets &&
          Object.keys(this.props.results.facets).length > 0 && (
            <div className="result-side-bar">
              <FiltersBar
                app={this.props.app}
                facets={this.props.results.facets}
                facetsNameMap={this.getFacetsFromApp()}
                staticFacetsMap={this.getStaticFacetsFromApp()}
                addFacet={this.props.addFacet}
                delFacet={this.props.delFacet}
                isFacetActive={this.props.isFacetActive}
                recordCount={this.props.results.meta.page.total_results}
              />
            </div>
          )}

        {this.props.showResponsiveMenu ? (
          <ResponsiveMenu
            showResponsiveMenu={this.props.toggleResponsiveMenu}
            app={this.props.app}
            facets={this.props.results.facets}
            facetsNameMap={this.getFacetsFromApp()}
            staticFacetsMap={this.getStaticFacetsFromApp()}
            addFacet={this.props.addFacet}
            delFacet={this.props.delFacet}
            isFacetActive={this.props.isFacetActive}
            resetFilters={this.props.resetFilters}
            sortField={this.props.sortField}
            changeSort={this.props.changeSort}
          />
        ) : (
          <div className="result-body">
            <ResultHeader
              app={this.props.app}
              info={this.props.results.meta}
              q={this.props.q}
              changeSort={this.props.changeSort}
              sortField={this.props.sortField}
              showResponsiveMenu={this.props.toggleResponsiveMenu}
            />
            <DidYouMean spelling={this.props.spelling}  push={this.props.push} />
            {this.props.results.meta.page.total_results === 0 && (
              <NoResults
                q={this.props.q}
                app={this.props.app}
                resetFilters={this.props.resetFilters}
              />
            )}
            <ResultList
              results={this.props.results}
              q={this.props.q}
              changeSort={this.props.changeSort}
              app={this.props.app}
              tClick={this.props.tClick}
            />
            {this.props.results.meta && (
              <Pagination
                {...this.props.results.meta.page}
                goToPage={this.props.goToPage}
                docType={this.props.docType}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default SearchResults;
